import { PayloadAction } from "@reduxjs/toolkit";
import moment from "moment-timezone";
import { takeLatest, all, put, call, select } from "redux-saga/effects";

import { commonMessages, ILocalizable } from "infrastructure/localization";
import { notification } from "infrastructure/notification";

import { releasesManagerActions } from "./ReleasesManager.actions";
import { IGetReleasesRequest, IGetReleasesResponseRow, releasesManagerApi as api } from "./ReleasesManager.api";
import { IReleaseRow, IReleasesManagerFilter, IReleasesManagerFilterData, selectors } from "./ReleasesManager.state";

function* initializeExecute() {
  try {
    const statuses: ILocalizable[] = yield call(api.getReleaseStatuses);

    const filter: IReleasesManagerFilter = {
      data: { createdDate: "", releaseDate: "" },
      statuses: statuses
    };
    yield put(releasesManagerActions.initializeCompleted(filter));
  } catch (error) {
    yield put(releasesManagerActions.loadingFailed(notification.error(error).useMessageId(commonMessages.error("searchFailed"))));
  }
}

function* searchExecute({ payload }: PayloadAction<IReleasesManagerFilterData | undefined>) {
  try {
    const filterData: IReleasesManagerFilterData = payload || (yield select(selectors.getFilterData));

    const request: IGetReleasesRequest = {
      filterName: filterData.filterName,
      status: filterData.selectedStatus?.messageId.value,
      createdDate: filterData.createdDate,
      releaseDate: filterData.releaseDate
    };

    const releaseRows: IGetReleasesResponseRow[] = yield call(api.getReleases, request);

    const releases = releaseRows.map<IReleaseRow>(r => ({
      releaseId: r.releaseId,
      name: { messageId: { value: r.name.messageId }, text: r.name.text },
      status: { value: r.status },
      releaseDate: r.releaseDate
        ? moment(r.releaseDate)
            .tz("America/Detroit")
            .format()
        : undefined,
      createdDate: moment(r.createdDate)
        .tz("America/Detroit")
        .format()
    }));

    yield put(releasesManagerActions.searchCompleted(releases));
  } catch (error) {
    yield put(releasesManagerActions.loadingFailed(notification.error(error).useMessageId(commonMessages.error("searchFailed"))));
  }
}

function* actionWatcher() {
  yield takeLatest(releasesManagerActions.initialize.toString(), initializeExecute);
  yield takeLatest(releasesManagerActions.search.toString(), searchExecute);
}

export function* releasesManagerSaga() {
  yield all([actionWatcher()]);
}
